module.exports = __webpack_public_path__ + "static/img/img9.30d04fbd.png";